exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".sn-cal-title {\r\n    font-weight: bold;\r\n    font-size: 23px;\r\n    padding-top: 7px;\r\n}\r\n\r\n.usc-cal-legend {\r\n    display: inline;\r\n    padding: 0px 5px;\r\n}\r\n\r\n.usc-cal-legend i {\r\n    font-size: 13px;\r\n    padding-right: 5px;\r\n}\r\n\r\n.usc-planned {\r\n    color: #00ff00;\r\n}\r\n\r\n.usc-held {\r\n    color: #1e90ff;\r\n}\r\n\r\n.usc-not-held {\r\n    color: #ff0000;\r\n}\r\n\r\n.usc-rescheduled {\r\n    color: #e3bc08;\r\n}\r\n\r\n.usc-unassigned {\r\n    color: #b202b2;\r\n}\r\n\r\n.usc-cal-filter {\r\n    padding: 8px;\r\n}\r\n\r\n.usc-store .loading {\r\n    text-align: center;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Azure/Source/Workspaces/SalesNOW/SalesSOLO/WebSites/SalesSOLO.Web.Angular.telesales/src/app/components/usc-store/usc-calendar-view/usc-calendar-view.component.css
// module id = ../../../../../src/app/components/usc-store/usc-calendar-view/usc-calendar-view.component.css
// module chunks = main